import { render, staticRenderFns } from "./DownloadVideoFooter.vue?vue&type=template&id=71ff48ce&scoped=true"
import script from "./DownloadVideoFooter.vue?vue&type=script&lang=js"
export * from "./DownloadVideoFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff48ce",
  null
  
)

export default component.exports